import _ from 'lodash';
// @mui
import { Stack } from '@mui/system';
import { Box } from '@mui/material';
//components
import FormCreator from 'components/FormCreator';
import { fieldType, validationTypes, invalidFields, fieldsGroupType } from 'components/FormCreator/types';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getNewPay } from 'state/reducers/pay.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
//sections
import { FormCard } from 'theme/elements/Forms';
import { FormHeader1 } from 'theme/elements/Headers';
//constants
import { PayEnum, Pay } from 'constants/pay.constants';
import { useMemo } from 'react';
import { getFormattedNumber } from 'utils';

export default function PaymentDetailsForm(props: { handleChange: any; invalidFields: invalidFields; currency: any }) {
  const t = useAppSelector(selectTranslations);
  const pay: Pay = useAppSelector(getNewPay);
  const prefixFields = 'page.pay.create.step.2.beneficiary_payment_details.';
  const { currency } = props;

  const amountValidations =useMemo(()=>{
    const validations = [validationTypes.requierd]
    if(!(currency.decimalPlaces>0)) {
      return validations.concat(validationTypes.noDecimalAllowed)
    }
    return validations
  },[currency])
  return (
    <Box component="form" noValidate>
      <FormCard>
        <FormHeader1
          title={t('page.pay.create.step.2.beneficiary_payment_details.title')}
          text={t('page.pay.create.step.2.beneficiary_payment_details.text')}
        />
        <Stack spacing={2}>
          <FormCreator
            initialValidation={props.invalidFields}
            name="localPayment"
            handleChange={props.handleChange}
            fieldsGroups={[
              {
                type: fieldsGroupType.col,
                fields: [
                  {
                    type: fieldType.text,
                    validation: [validationTypes.requierd],
                    props: {
                      disabled: true,
                      name: PayEnum.beneficiaryId,
                      label: t(`${prefixFields}currency_id.text`),
                      value: currency?.name || '',
                    },
                  },
                  {
                    type: fieldType.text,
                    validation: [validationTypes.requierd],
                    props: {
                      required: true,
                      formatAsAmount: true,
                      name: PayEnum.amount,
                      label: t(`${prefixFields}amount.text`),
                      placeholder: currency?.symbol + t(`${prefixFields}amount.placeholder`),
                      value: pay?.amount || '',
                      helperText:
                        t(`${prefixFields}available_amount.text`) + ' ' +
                        currency?.symbol +
                        getFormattedNumber(currency?.amount),
                    },
                  },
                ],
              },
            ]}
          />
        </Stack>
      </FormCard>
    </Box>
  );
}
